import React from "react";
import clsx from "clsx";
import { Grid } from "@mui/material";
import { Card } from "@curves/ui-base";
import { ReadTextField } from "@icoach/components";
import { isEqual } from "@util/utils";
import { ORDER_INVOICE_ISSUING_TYPE, INVOICE_CARRIER_TYPE } from "@icoach/constants/dataEnums";

const InvoiceSectionByRead = props => {
	const { titleClassName = "bg-light-active", sourceData = {} } = props;
	const { issuingType, issuingTypeText, carrierType, carrierTypeText, carrierNo, taxTitle, taxID, donationCode, cellPhone, mail } = sourceData.invoice || {};

	return (
		<React.Fragment>
			<Card.CardHeader title="發票資訊" className={clsx("px-4", titleClassName)} />
			<Card.CardContent className="p-4">
				<Grid spacing={3} container>
					<Grid xs={4} item>
						<ReadTextField label="發票類型">{issuingTypeText}</ReadTextField>
					</Grid>
					{isEqual(issuingType, 1) && (
						<Grid item xs={4}>
							<ReadTextField label="愛心碼">{donationCode}</ReadTextField>
						</Grid>
					)}
					{isEqual(issuingType, 2) && (
						<React.Fragment>
							<Grid item xs={4}>
								<ReadTextField label="發票載具">{carrierTypeText}</ReadTextField>
							</Grid>
							{(isEqual(carrierType, INVOICE_CARRIER_TYPE.MOBILEBARCODE) || isEqual(carrierType, INVOICE_CARRIER_TYPE.CITIZENDIGITALCERTIFICATE)) && (
								<Grid item xs={4}>
									<ReadTextField label="載具號碼">{carrierNo}</ReadTextField>
								</Grid>
							)}
						</React.Fragment>
					)}
					{isEqual(issuingType, ORDER_INVOICE_ISSUING_TYPE.TRIPLICATEUNIFORMINVOICE) && (
						<React.Fragment>
							<Grid item xs={4}>
								<ReadTextField label="統一編號">{taxID}</ReadTextField>
							</Grid>
							<Grid item xs={4}>
								<ReadTextField label="發票抬頭">{taxTitle}</ReadTextField>
							</Grid>
						</React.Fragment>
					)}
					<Grid xs={4} item>
						<ReadTextField label="寄送載具信箱">{mail}</ReadTextField>
					</Grid>
					<Grid xs={4} item>
						<ReadTextField label="通知手機號碼">{cellPhone}</ReadTextField>
					</Grid>
				</Grid>
			</Card.CardContent>
		</React.Fragment>
	);
};

export default InvoiceSectionByRead;
